import { ACTION_COLLECTION_INSERT_AFTER, ACTION_COLLECTION_INSERT_BEFORE, ACTION_COLLECTION_REMOVE, ACTION_OPTIONAL_REMOVE } from "../../Manifest/modules/editableComponentActions";

function xmlActionExecutor() {

    function cloneInnerFragment(xmlToEdit) {
        return xmlToEdit.getInnerFragment().cloneNode(true);
    }

    function insertBeforeAsync(targetNode, xmlToEdit) {
        return targetNode.insertBeforeAsync(cloneInnerFragment(xmlToEdit));
    }

    function insertAfterAsync(targetNode, xmlToEdit) {
        return targetNode.insertAfterAsync(cloneInnerFragment(xmlToEdit));
    }

    /**
     * Removes the specified node from its data source
     * @param targetNode {dataSourceNode} the node to remove
     * @returns a promise for the completed action
     */
    function remove(targetNode) {
        targetNode.deleteSelf();
    }

    /**
     * Returns the action function for the specified action type
     * @param actionName {string} - the action type to retrieve
     * @returns function(dsNode) the action to perform on the node
     */
    function actionForActionType(actionName) {
        switch (actionName) {
            case ACTION_COLLECTION_INSERT_BEFORE:
                return insertBeforeAsync;
            case ACTION_COLLECTION_INSERT_AFTER:
                return insertAfterAsync;
            case ACTION_COLLECTION_REMOVE:
            case ACTION_OPTIONAL_REMOVE:
                return remove;
        }

        return null;
    }

    /**
     * Performs an xmlToEdit action on a data source node
     * @param targetNode {dataSourceNode} the node upon which to act
     * @returns a promise for the completed action
     */
    async function performXmlToEditActionAsync(targetNode, action, xmlToEdit) {
        const actionFunc = actionForActionType(action);

        if (actionFunc) {
            return await actionFunc(targetNode, xmlToEdit);
        }

        throw new Error("Unsupported action type: " + action);
    }

    return {
        performXmlToEditActionAsync,
    };
}

export default xmlActionExecutor;